import { Form } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAcceptClientInvitationMutation } from './useAuthMutations';
import { getCurrentUserDashboardRoute } from '@utils/routing';

export const useAcceptClientInvitation = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const acceptMutation = useAcceptClientInvitationMutation();

    const token = searchParams.get('token') || '';

    const onFinish = async (values) => {
        if (!token) return;
        await acceptMutation.mutateAsync({
            token,
            name: values.name,
            password: values.password,
        });
        const dashboardRoute = getCurrentUserDashboardRoute();
        navigate(dashboardRoute, { replace: true });
    };

    return {
        form,
        loading: acceptMutation.isPending,
        onFinish,
        token,
        hasValidParams: Boolean(token),
    };
};
